import React from 'react';
import { View } from 'react-native';

import PropTypes from 'prop-types';

import { ErrorScreen, VFText } from '@vfgroup-oneplatform/foundation/Components';

import styles from './Budget.Styles';
import { BudgetLoading } from './Components';

const Budget = ({ isLoading, budget, error, onTryAgainPress }) => {
  const renderTitle = () => <VFText i18nKey="soho_budget_screen_title" style={styles.titleStyle} />;
  const renderError = () => (
    <ErrorScreen
      text={error?.message}
      style={styles.screenError}
      iconStyle={styles.errorIconStyle}
      onPress={onTryAgainPress}
    />
  );
  const renderContent = () => {
    let content = [renderTitle()];

    if (isLoading) {
      content = [<BudgetLoading />];
    } else if (error) {
      content.push(renderError());
    }
    return content;
  };
  return <View style={styles.containerStyle}>{renderContent()}</View>;
};

Budget.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  budget: PropTypes.array.isRequired,
  error: PropTypes.object.isRequired,
  onTryAgainPress: PropTypes.func,
};

export default Budget;
